/** @format */

const IconCategorySeasonality = () => (
  <svg width='68' height='10' viewBox='0 0 68 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1 5C6 1 12 1 17 5S28 9 34 5 45 1 51 5 62 9 67 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      fill='none'
    />
  </svg>
);

export default IconCategorySeasonality;
